import { render, staticRenderFns } from "./icn-close.vue?vue&type=template&id=599f57a4&scoped=true&"
import script from "./icn-close.vue?vue&type=script&lang=js&"
export * from "./icn-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f57a4",
  null
  
)

export default component.exports